// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"318":"d4e862f9","680":"2f1a86e7"}[chunkId] + ".js";
};